module.exports = __webpack_public_path__ + "static/media/cay.8bc7a3e5.svg";